import { API_LOCATION_URL } from 'infrastructure/config';
import {
    ISupportUserPasswordClient,
    IPostInput,
    IPostOutput,
} from 'interfaceAdapter/gatewaySchemas/ISupportUserPasswordClient';

const PATH = `${API_LOCATION_URL}/supporter/user/reset_password`;

export class SupportUserPasswordClient implements ISupportUserPasswordClient {
    async post(input: IPostInput): Promise<IPostOutput> {
        const { code, password } = input;
        const method = 'POST';
        const headers = {
            'Content-Type': 'application/json',
        };
        const body = JSON.stringify({ code, password });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
